import { AxiosPostType } from '../../../context/FetchProvider';

/**
 * Get user spreadjoy count.
 * @param {SessionPageRequest} req - Request.
 * @returns {number} - Count.
 */
export const getSpreadjoyCount = async (
  post: AxiosPostType,
): Promise<number> => {
  const { data } = await post<{ count: number }, undefined>(
    '/getUserSpreadjoy',
  );

  return data?.count || 0;
};
